<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="head"><span class="bold">The Emerging Revolutionary War Series</span></p>
<p class="fm"><span class="bold">offers compelling, easy-to-read overviews of some of the Revolutionary War’s most important battles and stories.</span></p>
<p class="fm"><span class="bold">Also part of the Emerging Revolutionary War Series:</span></p>
<p class="fm1"><em class="italic">A Single Blow: The Battles of Lexington and Concord and the Beginning of the American Revolution, April 19, 1775</em> by Phillip S. Greenwalt and Robert Orrison</p>
<p class="fm1"><em class="italic">A Handsome Flogging: The Battle of Monmouth, June 28, 1778</em> by William R. Griffith IV</p>
<p class="fm1"><em class="italic">The Winter that Won the War: The Winter Encampment at Valley Forge, 1777–1778</em> by Phillip S. Greenwalt</p>
<p class="fm1"><em class="italic">Unhappy Catastrophes: The American Revolution in Central New Jersey, 1776–1782</em> by Robert M. Dunkerly</p>
<p class="fm2"><span class="bold">Also by Mark Maloy</span></p>
<p class="fm1"><em class="italic">Victory or Death: The Battles of Trenton and Princeton, December 25, 1776–January 3, 1777</em></p>
<p class="fm3"><em class="italic">For a complete list of titles in the Emerging Revolutionary War Series, visit <span class="weblink"><a href="http://www.emergingrevolutionarywar.org" target="_blank"><span class="underline">www.emergingrevolutionarywar.org</span></a></span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Fm01.vue?e1a474c8